/**

// Check if debug mode is enabled (global)
const urlParams = new URLSearchParams(window.location.search);

 * Card Controller - Phase 7 Migration
 * Объединяет функциональность карточек документов
 */

import { generateCard } from './card-generator.js';
import { SciDoc } from './document-card.js';

/**
 * Card Controller Class
 * Управляет всеми операциями с карточками документов
 */
class CardController {
    constructor() {
        this.cards = new Map(); // Кэш созданных карточек
        this.cardTemplates = new Map(); // Шаблоны карточек
        this.isInitialized = false;
        
        // Initialization logging only in debug mode
    }
    
    /**
     * Инициализация контроллера карточек
     */
    initialize() {
        if (this.isInitialized) {
            return;
        }
        
        try {
            // Загружаем шаблон карточки
            this.loadCardTemplate();
            
            // Инициализируем события
            this.bindEvents();
            
            this.isInitialized = true;
            
            // Initialization logging only in debug mode
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[CardController] Initialization failed:', error);
            }
        }
    }
    
    /**
     * Загрузка шаблона карточки
     */
    loadCardTemplate() {
        const template = $('.document-card-template');
        if (template.length > 0) {
            this.cardTemplates.set('default', template);
        }
    }
    
    /**
     * Создание карточки документа - основная функция
     * Мигрировано из main.js generateCard()
     */
    generateCard(docName, docLink, docSize, appendTo, context = "") {
        return generateCard(docName, docLink, docSize, appendTo, context);
    }
    
    /**
     * Создание SciDoc объекта
     * Мигрировано из main.js class sciDoc
     */
    createSciDoc(fileName, fileLink, fileSize) {
        return new SciDoc(fileName, fileLink, fileSize);
    }
    
    /**
     * Обновление карточки
     */
    updateCard(cardId, newData) {
        const card = this.cards.get(cardId);
        if (!card) {
            if (debugMode === '1') {
                console.warn(`[CardController] Card ${cardId} not found`);
            }
            return false;
        }
        
        try {
            // Обновляем данные карточки
            if (newData.extract) {
                card.find('.card-extract').html(newData.extract);
            }
            
            if (newData.summary) {
                card.find('.card-summary').html(newData.summary);
            }
            
            return true;
            
        } catch (error) {
            if (debugMode === '1') {
                console.error(`[CardController] Failed to update card ${cardId}:`, error);
            }
            return false;
        }
    }
    
    /**
     * Обработка метаданных документа
     */
    processDocumentMetadata(doc, responseData) {
        try {
            const data = responseData.data || responseData;
            
            const metadata = {
                extract: data.extract ? 
                    data.extract
                        .replace(/^(# ([^\n]+)\n?|\(Note: )/g, '')
                        .replace(/^#+ ([^\n]+)/g, '<span class="text-secondary fw-bold">$1</span>')
                        .replace(/\n/g, '<br/>') 
                    : '',
                summary: data.summary || '',
                versions: data.versions || [],
                fileSize: doc.fileSize,
                fileName: doc.fileName
            };
            
            return metadata;
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[CardController] Failed to process metadata:', error);
            }
            return null;
        }
    }
    
    /**
     * Привязка событий карточек
     */
    bindEvents() {
        // Делегирование событий для динамически создаваемых карточек
        $(document).off('click.cardController', '.document-card')
                   .on('click.cardController', '.document-card', this.handleCardClick.bind(this));
                   
        $(document).off('keydown.cardController', '.document-card')
                   .on('keydown.cardController', '.document-card', this.handleCardNavigation.bind(this));
    }
    
    /**
     * Обработка клика по карточке
     */
    handleCardClick(event) {
        const card = $(event.currentTarget);
        const cardId = card.attr('data-card-id');
        
        if (window.HyperLog) {
            window.HyperLog.debug('[CardController] Card clicked:', { cardId });
        }
        
        // Можно добавить дополнительную логику обработки клика
        return true;
    }
    
    /**
     * Навигация по карточкам с клавиатуры
     */
    handleCardNavigation(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            this.handleCardClick(event);
        }
    }
    
    /**
     * Получение статистики карточек
     */
    getStats() {
        return {
            totalCards: this.cards.size,
            templatesLoaded: this.cardTemplates.size,
            isInitialized: this.isInitialized
        };
    }
}

// Создаем singleton instance
const cardController = new CardController();

// Register with migration controller
// Migration completed - no registration needed

// Global exports для backward compatibility
window.cardController = cardController;
window.generateCard = cardController.generateCard.bind(cardController);
window.createSciDoc = cardController.createSciDoc.bind(cardController);

// ES Module exports
export { cardController };
export const { generateCard: generateCardFunction, createSciDoc } = cardController; 